export const TEMPLATE_COOLDOWN_MS = 24 * 60 * 60 * 1000;
// This is the exact name returned by the approved WhatsApp template catalogue.
export const FORM_SUBMISSION_TEMPLATE = "envio_formulario";

export type TemplateSendingDecision =
  | { kind: "text" }
  | { kind: "template" }
  | { kind: "blocked"; waitMs: number };

export function decideTemplateSending({
  isCommercial,
  templateName,
  lastInboundAt,
  lastTemplateAt,
  now = Date.now(),
}: {
  isCommercial: boolean;
  templateName?: string;
  lastInboundAt?: number;
  lastTemplateAt?: number;
  now?: number;
}): TemplateSendingDecision {
  if (!isCommercial) return { kind: "template" };

  if (templateName === FORM_SUBMISSION_TEMPLATE) return { kind: "template" };

  if (lastInboundAt && now - lastInboundAt < TEMPLATE_COOLDOWN_MS) {
    return { kind: "text" };
  }

  if (lastTemplateAt && now - lastTemplateAt < TEMPLATE_COOLDOWN_MS) {
    return { kind: "blocked", waitMs: Math.max(0, TEMPLATE_COOLDOWN_MS - (now - lastTemplateAt)) };
  }

  return { kind: "template" };
}
